import { useState, useEffect } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import styles from '../../../pages/LeadCapture/QualifierManager/QualifierManager.module.css'
// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faSquareCheck, faSquareXmark, faBars } from '@fortawesome/free-solid-svg-icons'
// ------ Services ------ //
import * as webBridgeService from '../../../services/webBridgeService'
// ------ Components ------ //
import QualifierSelection from '../../../components/LeadCapture/QualifierManager/QualifierSelection'
// ------ Image Elements ------ //
const pencil = <FontAwesomeIcon icon={faPencil} style={{ width: '20px', height: '20px' }} />
const squareCheck = <FontAwesomeIcon icon={faSquareCheck} style={{ color: 'blue', width: '20px', height: '20px' }} />
const squareXmark = <FontAwesomeIcon icon={faSquareXmark} style={{ color: 'red', width: '20px', height: '20px' }} />
const bars = <FontAwesomeIcon icon={faBars} style={{ color: 'blue', width: '20px', height: '20px' }} />

const QualifierSetup = ({ index, qualifierItem, qualifierTypes, deleteQualifier, editQualifier, cancelEdit, editingId, provided, innerRef }) => {
    const [qualifierSelections, setQualifierSelections] = useState([])
    const [createSelection, setCreateSelection] = useState(false)
    const [newSelection, setNewSelection] = useState('')
    const [formData, setFormData] = useState(
        {
            id: qualifierItem.id ? qualifierItem.id : null,
            exhibitorId: qualifierItem.exhibitorId,
            exhibitorEmail: qualifierItem.exhibitorEmail,
            name: qualifierItem.name ? qualifierItem.name : null,
            displayOrder: qualifierItem.displayOrder ? qualifierItem.displayOrder : null,
            type: qualifierItem.type ? qualifierItem.type : null,
            typeName: qualifierItem.typeName ? qualifierItem.typeName : null,
            selections: [],
            visible: qualifierItem.visible ? qualifierItem.visible : true
        }
    )
    const isEditInvalid = () => {
        return !(formData.name && formData.typeName);
    }
    const handleDelete = async () => {
        // check if safe to delete
        if (qualifierItem.id && qualifierItem.id !== undefined && await webBridgeService.qualifierCheck(qualifierItem.id)) {
            // in use, don't allow delete
            alert("Qualifier is in use. Please change visibility instead of trying to delete.")
            return;
        }
        if (window.confirm('Are you sure you want to delete "' + qualifierItem.name + '"?') === true) {
            // delete entry from backend
            deleteQualifier(qualifierItem.id);
        }
    };

    const handleChange = (e) => {
        if (e.target.type === 'select-one') {
            var foundType = qualifierTypes.find((item) => item.name === e.target.value);
            if (foundType) {
                setFormData({
                    ...formData,
                    ['type']: foundType,
                    ['typeName']: foundType.name,
                })
            }
            else {
                setFormData({
                    ...formData,
                    ['type']: null,
                    ['typeName']: null,
                })
            }
        }
        else if (e.target.type === 'checkbox') {
            formData[e.target.name] = e.target.checked;
            setFormData({
                ...formData
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
    const handleSelectionChange = (e) => {
        if (e.target.value && e.target.value.length > 0) {
            setNewSelection(e.target.value);
        }

    }
    const handleQualifierSelectionSubmit = async e => {
        e.preventDefault()
        let holder = qualifierSelections
        if (newSelection && newSelection.length > 0) {
            holder.push(newSelection)
        }
        setQualifierSelections(holder);
        setNewSelection('')
        setCreateSelection(false);
    }
    const handleOnDragEnd = (result) => {
        if (!result.destination) return

        const items = Array.from(qualifierSelections)
        const [reorderedItem] = items.splice(result.source.index, 1)
        items.splice(result.destination.index, 0, reorderedItem)
        setQualifierSelections(items);
    }
    const submitSelectionEdit = (e, newSelection) => {
        e.preventDefault()

        let divId = parseInt(e.currentTarget.id.replace('edit', ''));
        //if (!divId) {
        //    e.current.id
        //}
        const items = qualifierSelections;//Array.from(qualifierSelections)
        items.splice(divId, 1);
        items.splice(divId, 0, newSelection);
        setQualifierSelections(items);
    }
    const selectionRemove = e => {
        e.preventDefault()
        const items = Array.from(qualifierSelections)
        let divId = parseInt(e.currentTarget.id.replace('remove', ''));
        items.splice(divId, 1);
        setQualifierSelections(items);
    } 
    const createQualifierSelection = e => {
        e.preventDefault()
        // keeps previous entry, if cancelled
        setCreateSelection(createSelection ? false : true)
    }
    const createSaveRequest = () => {
        const fieldsSave = {
            'id': formData.id,
            'exhibitorId': qualifierItem.exhibitorId,
            'exhibitorEmail': qualifierItem.exhibitorEmail,
            'name': formData.name,
            'displayOrder': formData.displayOrder,
            'typeName': formData.typeName,
            'visible': formData.visible,
            'selections': formData.typeName&& formData.typeName.toLowerCase() === 'dropdown' ? qualifierSelections: null,
            
        }
        return fieldsSave
    }

    const submitEdit = async e => {
        e.preventDefault()

        let saverequest = createSaveRequest();
        try {
            await webBridgeService.saveQualifier(saverequest)
        } catch (err) {
            console.log(err)
        }
        cancelEdit(formData);
        setCreateSelection(false);
    }
    useEffect(() => {
        setFormData(qualifierItem);
        if (qualifierItem.typeName && qualifierItem.typeName.length > 0) {
            var foundType = qualifierTypes.find((item) => item.name === qualifierItem.typeName);
            if (foundType) {
                setFormData({
                    ...formData,
                    ['type']: foundType,
                    ['typeName']: foundType.name,
                })
                if (foundType.name.toLowerCase() === 'dropdown' && qualifierItem.selections && qualifierItem.selections.length > 0) {
                    let holder = [];
                    if (qualifierItem.selections.indexOf('|') > 0) {
                        holder = qualifierItem.selections.split('|');
                    }
                    else {

                        holder.push(qualifierItem.selections);
                    }
                    setQualifierSelections(holder);
                }
            }
            else {
                setFormData({
                    ...formData,
                    ['type']: null,
                    ['typeName']: null,
                })
                setQualifierSelections([]);
            }
        }
      
    }, [])
    return (
        <>
            {editingId !== index.toString() ?
                <tr className={styles.trQualifiers}
                    key={qualifierItem.name + index}
                    {...provided.dragHandleProps}
                    {...provided.draggableProps}
                    ref={innerRef} >
                    <td className={styles.tdQualifiers}>
                        <i>{bars}</i>
                    </td>
                    <td className={styles.tdQualifiers}> {qualifierItem.name}</td>
                    <td className={styles.tdQualifiers}> {qualifierItem.typeName}</td>

                    {qualifierSelections && qualifierSelections.length > 0 ?
                        qualifierSelections.map((item, index) => (
                            <div key={index} className={styles.tdQualifiers}>
                                {item}
                            </div>
                        )) : <td className={styles.tdQualifiers}> N/A</td>}
                    <td className={styles.tdQualifiers}>
                            <input
                            tabIndex='13'
                            type="checkbox"
                            checked={formData.visible}
                            name="visible"
                            disabled='true'
                            style={{ width: '30px', height: '30px' } }
                            className={styles.fitCell} />
                    </td >
                    <td className={styles.tdAccounts}>
                        <button className={styles.editButton} onClick={e => editQualifier(e)} id={index} title="Edit qualifier.">
                            <i className={styles.buttonImage}>{pencil}</i>
                        </button>
                        <button onClick={e => handleDelete(e)} id={index} className={styles.removeButtons} title="Delete Qualifier">
                            <i className={styles.buttonImage} id={styles.remove}>
                                {squareXmark}
                            </i>
                        </button>
                    </td>
            </tr>
                :
                <tr className={styles.trAccounts} key={qualifierItem.name + index} >
                    <td className={styles.tdQualifiers}> </td>
                    <td className={styles.tdQualifiers}>
                        <input
                            type="text"
                            value={formData.name}
                            name="name"
                            onChange={handleChange}
                        />
                    </td>
                    <td className={styles.tdQualifiers}>
                        <select
                            name="typeName"
                            id={styles.QualifierTypeListDropdown}
                            value={formData.typeName}
                            onChange={handleChange}
                        >
                            <option disabled={true} value="" selected="selected">
                                -- Select an option --
                            </option>
                            {
                                qualifierTypes.map((ci, idx) => (
                                    <option key={idx}>{ci.name}</option>
                                ))
                            }
                        </select>
                    </td>
                    <td>   
                        {
                            formData.typeName.toLowerCase() === 'dropdown' ? 
                                <>
                                    <DragDropContext onDragEnd={handleOnDragEnd}>
                                        <Droppable droppableId="boxes">
                                            {(provided) => (
                                                <table className={styles.tableQualifiers}>
                                                    <thead>
                                                        <tr className={styles.trQualifiers}>
                                                            <th className={styles.thQualifiers}>
                                                                Order
                                                            </th>
                                                            <th className={styles.thQualifiers}>
                                                                Entry
                                                            </th>
                                                            <th className={styles.thQualifiers}>
                                                                Remove  
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody key={qualifierSelections.length} {...provided.droppableProps} ref={provided.innerRef}>
                                                        {qualifierSelections.map((item, index) => (
                                                            <Draggable key={index} draggableId={index.toString()} index={index}>
                                                                {(provided) => (
                                                                    <QualifierSelection
                                                                        qualifierEntry={item}
                                                                        removeSelection={selectionRemove}
                                                                        submitEdit={submitSelectionEdit}
                                                                        index={index}
                                                                        key={item + index}
                                                                        provided={provided}
                                                                        innerRef={provided.innerRef}>
                                                                    </QualifierSelection>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                    </tbody>

                                                </table>


                                            )}
                                        </Droppable>
                                    </DragDropContext>

                                    {
                                        createSelection ?
                                            <>
                                                <div className={styles.inputContainer}>
                                                    <label htmlFor="name" title='Qualifier selection option.' className={styles.label}
                                                        style={{ marginRight: '20px' }}>Entry:</label>
                                                    <textarea
                                                        autoComplete="off"
                                                        value={newSelection}
                                                        name="newSelection"
                                                        rows="2"
                                                        cols="35"
                                                        onChange={handleSelectionChange}
                                                    />
                                                </div>
                                            </> : <></>
                                    }
                                    <div className={styles.formQualifierContainer}>
                                        <button onClick={createQualifierSelection}  >
                                            {!createSelection ? "Add New Selection" : "Cancel"}
                                        </button>
                                        {createSelection ?
                                            <button className={styles.button} onClick={handleQualifierSelectionSubmit} style={{ marginLeft: '20px' }}>
                                                Add
                                            </button> : <></>}

                                    </div>
                            </>
                             
                            
                            :
                        <></>
                        }
                      
                    </td>
                    <td className={styles.tdQualifiers}>
                        <input
                            type="checkbox"
                            autoComplete="off"
                            checked={formData.visible}
                            name="visible"
                            onChange={handleChange}
                            style={{ width: '30px', height: '30px' }}
                            className={styles.formInput}
                        />
                    </td>
                    <td className={styles.tdQualifiers}>
                        <button onClick={e => submitEdit(e)} id={index} className={styles.editButtons} disabled={isEditInvalid()} title="Submit Edit">
                            <i className={styles.buttonImage} id={styles.editSubmit}>
                                {squareCheck}
                            </i>
                        </button>
                        <button onClick={e => cancelEdit(e)} id={index} className={styles.editButtons} title="Cancel Edit">
                            <i className={styles.buttonImage} id={styles.editCancel}>
                                {squareXmark}
                            </i>
                        </button>
                    </td>
                </tr>
            }
        </>
    );
}

export default QualifierSetup;
